module.exports = __webpack_public_path__ + "static/media/chefhub.3601904e.jpg";